import { useMemo } from 'react';
import { useEditorStateContext } from '../../context/notes/notes_editor_state_context';
export function useCounter() {
    const { currentMarkdownInEditor, maxCharacters, exceededCharacterLimit } = useEditorStateContext();
    return useMemo(() => ({
        count: currentMarkdownInEditor.length,
        maxCharacters,
        color: exceededCharacterLimit ? 'red50' : 'grey60',
        semibold: exceededCharacterLimit,
    }), [currentMarkdownInEditor.length, exceededCharacterLimit, maxCharacters]);
}
//# sourceMappingURL=use_counter.js.map